<template>
  <div class="image-swiper-module">
    <div class="image-swiper-wrapper" @mouseenter="stop()" @mouseleave="start()" @mousewheel.stop>
      <swiper :options="SwiperOptions" ref="imageSwiper">
        <swiper-slide v-for="(image, i) in data" :key="i">
          <div class="preview">
            <a :href="image.link" target="_blank">
              <img :src="image.previewUrl" alt="">
            </a>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>
<script>
export default {
  name: 'VideoSwiper',
  props: {data: Array},
  data () {
    return {
      SwiperOptions: {
        // basic
        width: window.innerWidth,
        resistanceRatio: 0,
        speed: 3000,
        observer: true,
        observeParents: true,
        slidesPerGroup: 1,
        // autoplay
        autoplay: {
          delay: 0,
          disableOnInteraction: false
        },
        freeMode: true,
        // loop
        loop: true,
        loopedSlides: this.data.length,
        loopAdditionalSlides: this.data.length,
        // grid
        centeredSlides: true,
        slidesPerView: 'auto',
        spaceBetween: 25
        // mousewheel
        // mousewheel: true
      }
    }
  },
  computed: {
    swiper () {
      return this.$refs.imageSwiper.swiper
    }
  },
  methods: {
    stop () {
      if (!this.$device.isMobile()) {
        this.lastNeedSwiperSpeed = Math.abs(Math.abs(this.swiper.getTranslate()) - Math.abs(this.swiper.translate)) / (220 + this.swiper.params.spaceBetween) * this.swiper.params.speed
        this.swiper.setTranslate(this.swiper.getTranslate())
        this.swiper.autoplay.stop()
      }
    },
    start () {
      if (!this.$device.isMobile()) {
        this.swiper.slideTo(this.swiper.activeIndex, this.lastNeedSwiperSpeed)
        this.swiper.autoplay.start()
      }
    }
  },
  mounted () {
    this.swiper.slideTo(0, 0, false)
    this.swiper.autoplay.start()
  }
}
</script>
<style lang="stylus" scoped>
.image-swiper-module
  .swiper-slide
    width 220px
    height 330px
    .preview img
      border-radius 7px
      width @width
      height @height

@media screen and (max-width: 1200px)
  .image-swiper-module
    .swiper-slide
      width 4.27rem
      height 6.4rem
      .preview img
        border-radius 0.3rem
        width @width
        height @height
</style>



// WEBPACK FOOTER //
// src/components/ImageSwiper.vue